export const GET_VOTING_POLLS = 'GET_VOTING_POLLS';
export const SET_VOTING_POLLS = 'SET_VOTING_POLLS';
export const SUBMIT_POLL_ANSWER = 'SUBMIT_POLL_ANSWER';
export const GET_POLL_ANSWERS = 'GET_POLL_ANSWERS';
export const CHECK_HAVE_VOTED = 'CHECK_HAVE_VOTED';
export const DELETE_USER_VOTE = 'DELETE_USER_VOTE';
